import VerticalListWithCount from './VerticalListWithCount';

export default VerticalListWithCount;
